<template>
  <div id="app">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'xllease'" href="static/dutchlease.css">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'leasevisie'" href="https://mhcmobility.nl/dist/assets/external/autodisk.css">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'dutchlease'" href="static/dutchlease.css">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'autoplanning'" href="static/autoplanning.css">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'huiskes-kokkeler'" href="static/hk.css">
    <link rel="stylesheet" v-if="$route.params.prefix.toLowerCase() == 'forward-lease'" href="static/forwardlease.css">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue